import React from 'react'
import AlertComponent from '@BUP/components/Generics/Alert'
import PageLayout from '@BUP/components/Layout/Page'
import { useTranslation } from 'react-i18next'
import styles from './historic-sociogram.module.scss'
import { useLocation } from 'react-router-dom'
import CollapseElement from './collapse-element'

const HistoricSociogramPage = () => {
  const i18n = useTranslation()
  const location = useLocation()
  const { results } = location.state

  if (!results || Object.keys(results).length === 0) {
    return (
      <PageLayout pageName={i18n.t('pages.data.historicalSociogram.title')}>
        <div className={styles.alert_wrapper}>
          <AlertComponent
            message={i18n.t('pages.data.historicalSociogram.results.empty')}
            type='warning'
          />
        </div>
      </PageLayout>
    )
  }

  const sortedResultsKeys = Object.keys(results).sort((a, b) => new Date(results[b].created_at) - new Date(results[a].created_at)).reverse()

  return (
    <PageLayout pageName={i18n.t('pages.data.historicalSociogram.title')}>
      <div className='collapse-wrapper'>
        <div className={styles.collapse_wrapper}>
          {sortedResultsKeys.map(year => {
            const sortedResults = results[year].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            return (
              <CollapseElement key={year} year={year} sortedResults={sortedResults} />
            )
          })}
        </div>
      </div>
    </PageLayout>
  )
}

export default HistoricSociogramPage
